import UpgradeSubscription from './UpgradeSubscription.component';

export default UpgradeSubscription;